"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _keys2 = _interopRequireDefault(require("lodash/keys"));

var _find2 = _interopRequireDefault(require("lodash/find"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _experimentActions = require("./common/experiment/experimentActions");

var _configActions = require("./common/dynamicConfig/configActions");

var _httpClient = _interopRequireDefault(require("./common/httpClient"));

var _cookieUtils = _interopRequireDefault(require("./common/utils/cookieUtils"));

var _analyticsUtils = require("./common/analytics/analyticsUtils");

var _urlCatalog = _interopRequireDefault(require("./common/urlCatalog"));

var _queryString = _interopRequireDefault(require("query-string"));

var _uuid = _interopRequireDefault(require("uuid"));

var _reduxForm = require("redux-form");

var _reduxResponsive = require("redux-responsive");

var _breakpoints = _interopRequireDefault(require("./common/maps/breakpoints"));

var _reduxMiddleware = require("./common/reduxMiddleware");

var _reduxPromiseMiddleware = _interopRequireDefault(require("redux-promise-middleware"));

var _reduxPersist = require("redux-persist");

var _constants = require("redux-persist/constants");

var _reduxActionBuffer = _interopRequireDefault(require("redux-action-buffer"));

var _storages = require("redux-persist/storages");

var _ensureAjsAnonymousIdCookie = _interopRequireDefault(require("./common/analytics/ensureAjsAnonymousIdCookie"));

var _authRedirectRouter = require("@angi/auth-redirect-router");

var _constants2 = require("./common/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var COOKIE_FEATURE_FLAGS = ['searchDisableAdvertisingBucketing'];

module.exports = function createAppInjectors() {
  var appInjectors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getLoginURL = _ref.getLoginURL,
      getLoginURL = _ref$getLoginURL === void 0 ? function () {
    return undefined;
  } : _ref$getLoginURL;

  return _objectSpread(_objectSpread({}, appInjectors), {
    beforePageMounted: function beforePageMounted() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (process.env.IS_BROWSER) {
        if (!window.AL) {
          window.AL = {};
        }

        (0, _ensureAjsAnonymousIdCookie.default)();

        _httpClient.default.addInterceptor({
          response: function response(_response) {
            // 401s are only allowed on non-authorized or /login routes
            if (props.authorized !== false && _response.status === 401) {
              if (_constants2.isClient) {
                _authRedirectRouter.browserAuthRedirectRouter.redirectToAuth(getLoginURL());
              }
            }

            return _response;
          }
        });
      }

      if (appInjectors && appInjectors.beforePageMounted) {
        appInjectors.beforePageMounted(props);
      }
    },
    beforeConfigureStore: function beforeConfigureStore(options, props) {
      // initialize urls
      var initialState = options.initialState;

      _urlCatalog.default.initialize({
        baseUrls: {
          member: (0, _get2.default)(initialState, 'config.memberUrl'),
          myAngi: (0, _get2.default)(initialState, 'config.myAngiUrl'),
          office: (0, _get2.default)(initialState, 'config.officeUrl'),
          drupal: (0, _get2.default)(initialState, 'config.drupalUrl')
        }
      });

      var isAuthenticatedUser = initialState.auth && initialState.auth.isAuthenticated;

      if (props.authorized !== false && isAuthenticatedUser === false) {
        if (_constants2.isClient) {
          _authRedirectRouter.browserAuthRedirectRouter.redirectToAuth(getLoginURL());
        }
      }

      var clientOnlyMiddleware = process.env.IS_BROWSER ? [(0, _reduxActionBuffer.default)(_constants.REHYDRATE)] : [];
      var storeOptions = {
        resetOnAction: 'LOGOUT',
        initialState: _objectSpread({}, initialState),
        middleware: [].concat((0, _toConsumableArray2.default)(options.middleware), [(0, _reduxMiddleware.injectionMiddleware)({
          getQueryParams: function getQueryParams() {
            return process.env.IS_BROWSER ? _queryString.default.parse(document.location.search) : {};
          }
        }), (0, _reduxPromiseMiddleware.default)({
          promiseTypeSuffixes: ['START', 'SUCCESS', 'ERROR']
        }), _reduxMiddleware.actionSideEffectMiddleware], clientOnlyMiddleware),
        enhancers: [].concat((0, _toConsumableArray2.default)(options.enhancers), [(0, _reduxPersist.autoRehydrate)(), (0, _reduxResponsive.createResponsiveStoreEnhancer)({
          calculateStateInitially: false
        }), (0, _reduxMiddleware.immutableToJS)()]),
        reducers: _objectSpread(_objectSpread({}, (options || {}).reducers), {}, {
          browser: (0, _reduxResponsive.createResponsiveStateReducer)(_breakpoints.default),
          form: _reduxForm.reducer,
          auth: require('./common/auth/authReducer'),
          analytics: require('./common/analytics/analyticsReducer'),
          dynamicConfig: require('./common/dynamicConfig/configReducer'),
          experiment: require('./common/experiment/experimentReducer'),
          experimentV2: require('./common/experiment/v2/experimentReducer'),
          session: require('./common/session/sessionReducer').default,
          textToDownload: require('./common/textToDownload/textToDownloadReducer')
        })
      }; // For backwards compatibility, existing ions with props.noUser = true and props.authorized = false
      // will always be initialized with auth.isAuthenticated = false (e.g. member-app notFound)

      if (props.noUser === true && props.authorized === false && storeOptions.initialState.auth) {
        storeOptions.initialState.auth.isAuthenticated = false;
      }

      if (appInjectors && appInjectors.beforeConfigureStore) {
        return _objectSpread(_objectSpread({}, storeOptions), appInjectors.beforeConfigureStore(storeOptions, props));
      }

      return storeOptions;
    },
    afterConfigureStore: function afterConfigureStore(store) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var storeOptions = arguments.length > 2 ? arguments[2] : undefined;

      // Setup redux-persist
      if (process.env.IS_BROWSER) {
        (0, _reduxPersist.persistStore)(store, {
          // Whitelist only reducers that have a "persist" value set to "true"
          whitelist: Object.keys(storeOptions.reducers || {}).filter(function (key) {
            return storeOptions.reducers[key].persist === true;
          }),
          debounce: props.persistDebounce || 500,
          storage: _storages.asyncSessionStorage,
          keyPrefix: 'reduxPersist:'
        }, function () {
          if (storeOptions.enableLogger) {
            console.log('Rehydration of redux store is complete.');
          }
        });
      }

      var storeState = store.getState(); // Set gateway header values before any store.dispatch calls which may trigger service actions

      var appName = (0, _get2.default)(storeState, 'config.appName');
      var appVersion = (0, _get2.default)(storeState, 'config.appVersion');

      _httpClient.default.addInterceptor({
        request: function request(_request) {
          _request.headers.set('X-ANGI-ProxyVersion', '1');

          _request.headers.set('X-ANGI-RequestId', _uuid.default.v1());

          _request.headers.set('X-ANGI-SourceApplication', appName);

          _request.headers.set('X-ANGI-ApplicationVersion', appVersion);

          _request.headers.set('pragma', 'no-cache');

          if (process.env.IS_BROWSER) {
            if (!_request.headers.has('X-ANGI-TaxonomyName')) {
              // https://angieslist.atlassian.net/browse/GUESS-5742
              // HA Task Taxonomy Test
              // This is a non-target, custom test with manual allocation and variation stored in a cookie
              var maybeHaTaskTaxonomyTestVariation = _cookieUtils.default.getCookie('haTaskTaxonomyTestTaxonomyName');

              if (maybeHaTaskTaxonomyTestVariation === 'HaTask') {
                _request.headers.set('X-ANGI-TaxonomyName', 'HA Task');
              } else {
                _request.headers.set('X-ANGI-TaxonomyName', 'Ad Platform');
              }
            }

            var queryParams = _queryString.default.parse(window.location.search);

            var token = (0, _get2.default)(queryParams, (0, _find2.default)((0, _keys2.default)(queryParams), function (k) {
              return k.match(/onetimetoken/i);
            }));

            if (token) {
              _request.headers.set('Authorization', 'OneTime '.concat(token));
            }

            var cookieFFString = COOKIE_FEATURE_FLAGS.reduce(function (cookieKeyVals, cookieKey) {
              var cookieVal = _cookieUtils.default.getCookie(cookieKey);

              return (0, _isEmpty2.default)(cookieVal) ? cookieKeyVals : [].concat((0, _toConsumableArray2.default)(cookieKeyVals), ["".concat(cookieKey, "=").concat(cookieVal)]);
            }, []).join();

            if (cookieFFString !== '') {
              _request.headers.set('X-ANGI-FeatureFlags', cookieFFString);
            } // Get anonymousId from the Segment cookie


            var anonymousIdCookieValue = (_cookieUtils.default.getCookie('ajs_anonymous_id') || '').replace(/%22/g, '');

            if (!(0, _isEmpty2.default)(anonymousIdCookieValue)) {
              _request.headers.set('X-ANGI-AnonymousId', anonymousIdCookieValue);
            }

            var epid = _cookieUtils.default.getCookie('epid');

            if (epid) {
              _request.headers.set('X-ANGI-EntryPointId', epid);
            }

            var adobeMarketingCloudVistorId = _cookieUtils.default.getValueFromAdobeAnalyticsCookie('MCMID');

            if (adobeMarketingCloudVistorId) {
              _request.headers.set('X-ANGI-MarketingCloudVisitorId', adobeMarketingCloudVistorId);
            }

            var referrer = document.referrer;

            if (referrer) {
              _request.headers.set('X-ANGI-OriginalReferrerUrl', referrer);
            }
          }

          if (!_request.headers.has('X-ANGI-TaxonomyName')) {
            _request.headers.set('X-ANGI-TaxonomyName', 'Ad Platform');
          }

          return _request;
        }
      });

      var shouldGetFeatureFlags = true;

      if (process.env.IS_BROWSER) {
        var queryParams = _queryString.default.parse(location.search);

        (0, _analyticsUtils.persistCampaignIds)(storeState, queryParams);

        if (queryParams.experiments) {
          shouldGetFeatureFlags = false; // Set the methods to empty since we will only honor experiments from the query string if they are specified

          window.AL.setExperiment = function () {};

          window.AL.setExperiments = function () {};

          var experiments = {};
          queryParams.experiments.split(' ').forEach(function (experiment) {
            var parts = experiment.split('|');
            experiments[parts[0]] = parts[1] === undefined ? true : parts[1];
            /* eslint no-console:0 */

            console.log("Setting experiment '".concat(parts[0], "' to '").concat(experiments[parts[0]], "'"));
          });
          store.dispatch((0, _experimentActions.setExperiments)(experiments));
        } else {
          // Handle window.AL.preloadExperiments
          if (window.AL.preloadExperiments) {
            store.dispatch((0, _experimentActions.setExperiments)(window.AL.preloadExperiments));
          } // Expose the 'setExperiment' method on the 'window' object for use by 3rd parties to enable/disable experiments


          window.AL.setExperiment = function (name, data) {
            return store.dispatch((0, _experimentActions.setExperiment)(name, data));
          };

          window.AL.setExperiments = function (experiments) {
            return store.dispatch((0, _experimentActions.setExperiments)(experiments));
          };
        }

        store.dispatch((0, _reduxResponsive.calculateResponsiveState)(window));
      }

      var dynamicConfigRoot = (0, _get2.default)(storeState, 'config.dynamicConfigRoot');

      if (dynamicConfigRoot) {
        store.dispatch((0, _configActions.getDynamicConfig)(dynamicConfigRoot));
      }

      if (shouldGetFeatureFlags) {
        store.dispatch((0, _experimentActions.getFeatureFlags)((0, _get2.default)(storeState, 'config.featureFlagUrl', '/feature_flags')));
      }

      if (appInjectors && appInjectors.afterConfigureStore) {
        appInjectors.afterConfigureStore(store, props);
      }
    }
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/createAppInjectors.js
// module id = 4399
// module chunks = 25